import React from 'react'
import CheckIcon from 'material-ui/svg-icons/navigation/check'
import CloseIcon from 'material-ui/svg-icons/navigation/close'
import { getDescription } from '../../state/constants'
import styles from './styles/TextStatusIndicator'

const TextStatusIndicator = ({ status, errorCode }) => {
  const errorDescription = getDescription(errorCode)
  const badStatus = ['undelivered', 'failed'].includes(status)

  let style, icon
  switch (true) {
    case badStatus: {
      icon = <CloseIcon style={styles.failure} />
      style = styles.container_failure
      break
    }
    case status === 'delivered': {
      icon = (
        <div>
          <CheckIcon style={styles.delivered} />
          <CheckIcon style={styles.delivered_2} />
        </div>
      )
      style = styles.container_delivered
      break
    }
    default: {
      icon = <CheckIcon style={styles.sent} />
      style = styles.container
    }
  }

  return (
    <div>
      <div style={style}>{icon}</div>
      {badStatus && (
        <div style={styles.errorDescription}>
          {errorDescription}
        </div>
      )}
    </div>
  )
}

export default TextStatusIndicator



// WEBPACK FOOTER //
// ./src/components/Messages/TextStatusIndicator.js